var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCheckmarkcircleOutlineBrand = function SvgCheckmarkcircleOutlineBrand(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M12 20.987a8.987 8.987 0 1 0 0-17.974 8.987 8.987 0 0 0 0 17.974M12 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10-4.477 10-10 10m-5.823-9.114a.66.66 0 0 0 0 .933l2.729 2.859a.66.66 0 0 0 .933 0l6.892-7.036a.66.66 0 0 0-.934-.933l-6.425 6.569-2.262-2.392a.66.66 0 0 0-.933 0",
    clipRule: "evenodd"
  })));
};
export default SvgCheckmarkcircleOutlineBrand;